export enum CarouselStep {
    ProductList = 0,
    ProfessionalList = 1,
    ReferenceYear = 2,
    OrderUser = 3,
    ContactInfoSelection = 4,
    Discount = 5,
    InitPayment = 6
}